import React, { useState, useEffect, useRef } from "react";
import styles from './formcompra.module.css';
import vendastyles from './formvenda.module.css';
import ui from '../../styles/ui.module.css';
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import Calculadora from "../Calculadora/index";
import { CgCalculator } from "react-icons/cg";
import { FiX } from "react-icons/fi";
import api from "../../services/api";
import { fetchRatesForDate } from "../../utils/currencyRates";
import ConfirmModal from "../ConfirmModal";

const FormularioCompra = ({ formData = {}, onNewSubmission, toggleFormulario, onSwitchOperacao, onImportarBinance }) => {
  const { register, handleSubmit, control, watch, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      data: "",
      compraBobDia: "",
      nomeBRL: "",
      idCliente: null,
      valorBRL: "",
      nomeBOB: "",
      valorBOB: "",
      exchange: 1,
      usdtPrecoUn: "",
      comissaoExchange: "",
      usdtQuantidade: "",
    },
  });

  const exchangeSelecionado = watch('exchange');
  const nomeBRLValue = watch('nomeBRL');
  const dataValue = watch('data');
  const valorBRLValue = watch('valorBRL');
  const valorBOBValue = watch('valorBOB');

  const clienteInputRef = useRef(null);
  const [showCalculadora, setShowCalculadora] = useState(false);
  const [campoDestino, setCampoDestino] = useState("");
  const [rateForDate, setRateForDate] = useState(null);
  // Autocomplete estados
  const [sugestoes, setSugestoes] = useState([]);
  const [todosClientes, setTodosClientes] = useState([]);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [sugestaoSelecionada, setSugestaoSelecionada] = useState(-1);
  const autocompleteRef = useRef(null);
  const isEditing = !!(formData && formData.id);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingData, setPendingData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      reset({
        data: formData.data || "",
        compraBobDia: formData.compraBobDia ?? "",
        nomeBRL: formData.nomeBRL || "",
        idCliente: formData.idCliente ?? null,
        valorBRL: formData.valorBRL ?? "",
        nomeBOB: formData.nomeBOB || "",
        valorBOB: formData.valorBOB ?? "",
        exchange: formData.exchange ?? 1,
        usdtPrecoUn: formData.usdtPrecoUn ?? "",
        comissaoExchange: formData.comissaoExchange ?? "",
        usdtQuantidade: formData.usdtQuantidade ?? "",
      });
    }
  }, [formData, reset]);

  // Prefill com última venda (para manter consistência visual)
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) return;
    (async () => {
      try {
        const { start, end } = getMonthRange();
        const res = await api.get('/vendas', { params: { dataInicio: start, dataFim: end } });
        const arr = Array.isArray(res.data) ? res.data : [];
        if (!arr.length) return;
        const last = arr.reduce((a, b) => (Number(b.ID || 0) > Number(a.ID || 0) ? b : a), arr[0]);
        if (last?.DATA) setValue('data', last.DATA, { shouldValidate: true });
        if (last?.COMPRABOBDIA !== undefined && last?.COMPRABOBDIA !== null) setValue('compraBobDia', String(last.COMPRABOBDIA), { shouldValidate: true });
      } catch {}
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Carrega clientes para autocomplete
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/clientes');
        setTodosClientes(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        // silenciar
      }
    })();
  }, []);

  useEffect(() => {
    if (!dataValue) {
      setRateForDate(null);
      return undefined;
    }
    let canceled = false;
    const loadRate = async () => {
      const formatted = String(dataValue).slice(0, 10);
      if (!formatted) return;
      try {
        const fetched = await fetchRatesForDate(formatted);
        if (canceled) return;
        setRateForDate(fetched);
        if (fetched?.BRL > 0) {
          setValue('usdtPrecoUn', String(fetched.BRL).replace('.', ','));
        }
      } catch (error) {
        if (!canceled) setRateForDate(null);
      }
    };
    loadRate();
    return () => {
      canceled = true;
    };
  }, [dataValue, setValue, fetchRatesForDate]);

  const buscarSugestoes = (texto) => {
    if (!texto || !texto.trim()) {
      setSugestoes([]);
      setMostrarSugestoes(false);
      return;
    }
    const lc = texto.toLowerCase();
    const dg = texto.replace(/\D/g, '');
    const list = (todosClientes || [])
      .filter(c => String(c.NOME || '').toLowerCase().includes(lc) || (dg.length >= 3 && String(c.CPF || '').replace(/\D/g,'').includes(dg)))
      .slice(0, 20)
      .map(c => ({ id: c.ID, nome: c.NOME, cpf: c.CPF || '', fone: c.WHATSAPP_NUMERO || c.TELEFONE || '' }));
    setSugestoes(list);
    setMostrarSugestoes(true);
    setSugestaoSelecionada(-1);
  };

  // Atualiza sugestões conforme digita
  useEffect(() => {
    buscarSugestoes(nomeBRLValue);
  }, [nomeBRLValue, todosClientes]);

  // Fecha lista ao clicar fora
  useEffect(() => {
    const onDocClick = (e) => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(e.target)) {
        setMostrarSugestoes(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const selecionarCliente = (cli) => {
    setValue('nomeBRL', cli.nome, { shouldValidate: true });
    setValue('idCliente', cli.id, { shouldValidate: true });
    setMostrarSugestoes(false);
    setSugestaoSelecionada(-1);
    try { clienteInputRef.current?.focus?.(); } catch {}
  };

  const toNum = (v) => {
    if (v === null || v === undefined) return 0;
    const s = String(v).replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  };

  useEffect(() => {
    if (String(exchangeSelecionado) !== '2') {
      setValue('usdtQuantidade', '');
    }
  }, [exchangeSelecionado, setValue]);

  const doSubmit = async (data) => {
    if (!data.nomeBRL || !data.valorBRL || !data.data || !data.compraBobDia) {
      toast.warn("Preencha os campos obrigatórios.");
      return;
    }
    // Valida existência de taxa BRL para a data (preenche USDT Preço Unitário via taxa)
    const formattedDate = String(data.data || '').slice(0, 10);
    if (!formattedDate) {
      toast.error('Data inválida para calcular a taxa BRL.');
      return;
    }
    const fetchedRates = await fetchRatesForDate(formattedDate);
    const rate = fetchedRates?.BRL || 0;
    if (!(rate > 0)) {
      toast.error('Não há taxa BRL cadastrada para esta data. Cadastre em Consultas > Taxas.');
      return;
    }
    setRateForDate(fetchedRates);
    // idCliente opcional: backend tenta resolver por nome quando possível

    const compraBobDiaNum = toNum(data.compraBobDia);
    const valorBOBNum = toNum(data.valorBOB);
    const valorBRLNum = toNum(data.valorBRL);
    const usdtPrecoUn = toNum(data.usdtPrecoUn) || rate; // garante envio do rate
    const comissaoExchange = toNum(data.comissaoExchange);
    const exchangeNumero = parseInt(data.exchange, 10) || 1;
    const qtdeBruta = data.usdtQuantidade;
    const usdtQuantidadeNum = String(qtdeBruta ?? '').trim() === '' ? 0 : toNum(qtdeBruta);

    if (exchangeNumero === 2 && !(usdtQuantidadeNum > 0)) {
      toast.warn('Informe a quantidade de crypto comprada.');
      return;
    }

    const payload = {
      data: data.data,
      compraBobDia: compraBobDiaNum,
      nomeBRL: data.nomeBRL,
      idCliente: data.idCliente,
      valorBRL: valorBRLNum,
      nomeBOB: data.nomeBOB,
      valorBOB: valorBOBNum,
      exchange: exchangeNumero,
      usdtPrecoUn,
      comissaoExchange,
      usdtQuantidade: usdtQuantidadeNum > 0 ? usdtQuantidadeNum : undefined,
      id: formData?.id || null,
    };

    try {
      setIsSubmitting(true);
      if (typeof onNewSubmission === 'function') {
        const result = await onNewSubmission(payload, 'COMPRA');
        if (result?.ok === true || (result?.status && result.status >= 200 && result.status < 300) || result === undefined) {
          toast.success(isEditing ? 'Compra atualizada com sucesso' : 'Compra lançada com sucesso');
        } else if (result?.ok === false) {
          const msg = result?.message || result?.error || 'Erro ao lançar compra';
          toast.error(msg);
        }
      }
      // Limpa formulário após salvar/atualizar; se edição, fecha
      const empty = { data: '', compraBobDia: '', nomeBRL: '', idCliente: null, valorBRL: '', nomeBOB: '', valorBOB: '', exchange: 1, usdtPrecoUn: '', comissaoExchange: '', usdtQuantidade: '' };
      setTimeout(() => {
        reset(empty);
        if (isEditing && typeof toggleFormulario === 'function') toggleFormulario();
        if (!isEditing && clienteInputRef.current) clienteInputRef.current.focus();
      }, 0);
    } catch (e) {
      const msg = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'Erro ao lançar compra';
      toast.error(msg);
      console.error('Erro ao enviar compra:', e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSubmit = (data) => {
    setPendingData(data);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    if (isSubmitting) return;
    setConfirmOpen(false);
  };

  const handleConfirm = async () => {
    if (!pendingData || isSubmitting) return;
    setConfirmOpen(false);
    await doSubmit(pendingData);
  };

  // Preenche automaticamente compraBobDia = VALORBOB / VALORBRL e USDT Preço Unit = BRL da data
  // Preenche automaticamente compraBobDia = VALORBOB / VALORBRL
  useEffect(() => {
    const toNum = (v) => {
      if (v === null || v === undefined) return 0;
      const s = String(v).replace(',', '.');
      const n = parseFloat(s);
      return Number.isFinite(n) ? n : 0;
    };
    const nBRL = toNum(valorBRLValue);
    const nBOB = toNum(valorBOBValue);
    if (nBRL > 0 && nBOB > 0) {
      const taxa = nBOB / nBRL;
      setValue('compraBobDia', taxa.toFixed(2), { shouldValidate: true });
    }
  }, [valorBRLValue, valorBOBValue, setValue]);

  const abrirCalculadora = (campo) => { setCampoDestino(campo); setShowCalculadora(true); };
  const aoFecharCalculadora = (resultado) => {
    if (resultado !== null) {
      setValue(campoDestino, resultado, { shouldValidate: true, shouldDirty: true });
    }
    setShowCalculadora(false);
    setCampoDestino("");
  };

  return (
    <div className={vendastyles['venda-form-compovend']}>
      <ConfirmModal
        open={confirmOpen}
        message="Confirmar lançamento desta compra?"
        onConfirm={handleConfirm}
        onCancel={closeConfirm}
        loading={isSubmitting}
        confirmClassName={`${ui.butdesktop} ${ui.btnPrimary}`}
        cancelClassName={ui.butdesktop}
      />
      
        <h3 className={`${ui.titg}`}>{isEditing ? 'Editar compra' : 'Lançar compras do dia'}</h3>
        <button
          type="button"
          className={`${ui.butfechar}`}
          onClick={() => typeof toggleFormulario === 'function' && toggleFormulario()}
          aria-label="Fechar formulário de compra"
        >
          <FiX size={18} />
        </button>
      
      <div className={vendastyles['venda-compra']}>
        <button className={vendastyles['btn-venda']} type="button" onClick={() => typeof onSwitchOperacao === 'function' && onSwitchOperacao('VENDA')}>
          Venda
        </button>
        <button className={`${vendastyles['btn-compra']} ${vendastyles['active']}`} type="button">
          Compra
        </button>
      </div>
      
      <form onSubmit={handleSubmit(onSubmit)} className={vendastyles['venda-formulario']}>
        <div className={vendastyles['venda-form-toolbar']}>
          <button
            type="button"
            className={`${ui.butdesktop} ${ui.btnSecondary}`}
            onClick={() => typeof onImportarBinance === 'function' && onImportarBinance()}
          >
            Importar CSV Binance
          </button>
        </div>
        <div className={vendastyles['venda-dataecompra']}>
          <div>
            <label className={`${ui.labdesktop}`}>Data</label>
            
            <input className={`${ui.inpdesktop}`} type="date" {...register("data", { required: "Data é obrigatória" })} />
            {errors.data && <span>{errors.data.message}</span>}
          </div>
          <div>
            <label className={`${ui.labdesktop}`}>T.Compra BOB</label>
            <input className={`${ui.inpdesktop}`} type="text" placeholder="Taxa de compra (BOB/dia)" title="Taxa de compra do dia (BOB por unidade)" readOnly
              {...register("compraBobDia", { required: "Compra é obrigatória", pattern: { value: /^\d+(?:[\.,]\d{1,2})?$/, message: "Use até 2 casas (ponto ou vírgula)" } })}
            />
            {errors.compraBobDia && <span>{errors.compraBobDia.message}</span>}
          </div>
        </div>

        <div className={vendastyles['venda-exchange']}>
          <div className="">
            <label className={`${ui.labdesktop}`}>Exchange</label>
            <select  className={`${ui.seldesktop}`} {...register('exchange')} title="1=SEM, 2=COM">
              <option value={1}>Sem exchange</option>
              <option value={2}>Com exchange</option>
            </select>
          </div>
          <div className={vendastyles['venda-quantidade-usdt']}>
            <label className={`${ui.labdesktop}`}>Quantidade (USDT)</label>
            <input
              className={`${ui.inpdesktop}`}
              type="text"
              placeholder="Q.(USDT)"
              {...register('usdtQuantidade', {
                validate: (valor) => {
                  if (String(exchangeSelecionado) !== '2') return true;
                  const preenchido = String(valor ?? '').trim();
                  if (!preenchido) return 'Informe a quantidade de crypto comprada.';
                  const numero = toNum(preenchido);
                  return numero > 0 || 'Informe a quantidade de crypto comprada.';
                }
              })}
            />
            {errors.usdtQuantidade && <span>{errors.usdtQuantidade.message}</span>}
          </div>
          <div className="">
            <label className={`${ui.labdesktop}`}>USDT Preço Unitário</label>
            <input
              className={`${ui.inpdesktop}`}
              type="text"
              placeholder="USDT P. U."
              {...register('usdtPrecoUn', {
                pattern: { value: /^\d+(?:[\.,]\d{1,6})?$/, message: 'Até 6 casas (ponto ou vírgula)' }
              })}
            />
            {errors.usdtPrecoUn && <span>{errors.usdtPrecoUn.message}</span>}
          </div>
          <div className="">
            <label className={`${ui.labdesktop}`}>Comissão Exchange</label>
            <input className={`${ui.inpdesktop}`} type="text" placeholder="Comissão Exchange" {...register('comissaoExchange', { pattern: { value: /^\d+(?:[\.,]\d{1,2})?$/, message: 'Até 2 casas (ponto ou vírgula)' } })} />
            {errors.comissaoExchange && <span>{errors.comissaoExchange.message}</span>}
          </div>
        </div>
        <div className={vendastyles['venda-nomevalor']}>
          <div className={vendastyles['venda-autocomplete']} ref={autocompleteRef}>
            <label className={`${ui.labdesktop}`}>Nome BRL</label>
            <Controller
              name='nomeBRL'
              control={control}
              rules={{ required: 'Cliente BRL é obrigatório' }}
              render={({ field }) => (
                <input
                  className={`${ui.inpdesktop}`}
                  type="text"
                  placeholder="Cliente BRL"
                  {...field}
                  onChange={(e)=>{ field.onChange(e); setValue('idCliente', null, { shouldValidate: true }); buscarSugestoes(e.target.value); }}
                  onFocus={() => {
                    const cur = clienteInputRef.current?.value || '';
                    if (cur.trim().length > 0) buscarSugestoes(cur);
                  }}
                  onKeyDown={(e)=>{
                    if (mostrarSugestoes) {
                      if (e.key === 'ArrowDown') { e.preventDefault(); setSugestaoSelecionada((p)=> (p < sugestoes.length-1 ? p+1 : 0)); }
                      else if (e.key === 'ArrowUp') { e.preventDefault(); setSugestaoSelecionada((p)=> (p > 0 ? p-1 : sugestoes.length-1)); }
                      else if (e.key === 'Enter' && sugestaoSelecionada >= 0) { e.preventDefault(); selecionarCliente(sugestoes[sugestaoSelecionada]); }
                      else if (e.key === 'Escape') { setMostrarSugestoes(false); }
                    }
                  }}
                  onBlur={() => setTimeout(() => setMostrarSugestoes(false), 120)}
                  ref={(el)=>{ field.ref(el); clienteInputRef.current = el; }}
                />
              )}
            />
            {errors.nomeBRL && <span>{errors.nomeBRL.message}</span>}

            {mostrarSugestoes && (
              <ul className={vendastyles['venda-sugestoes']}>
                {sugestoes.length === 0 && (clienteInputRef.current?.value||'').trim().length>0 && (
                  <li className={`${vendastyles['venda-sugestao-item']} ${vendastyles['selecionada'] || ''}`}>Nenhum cliente encontrado</li>
                )}
                {sugestoes.map((cli, idx) => (
                  <li
                    key={cli.id}
                    className={`${vendastyles['venda-sugestao-item']} ${idx === sugestaoSelecionada ? (vendastyles['selecionada'] || '') : ''}`}
                    onMouseDown={(e) => { e.preventDefault(); selecionarCliente(cli); }}
                  >
                    <div style={{ display:'flex', flexDirection:'column' }}>
                      <strong>{cli.nome}</strong>
                      <span style={{ fontSize: 12, opacity: .8 }}>
                        CPF: {String(cli.cpf||'').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}
                        {cli.fone ? ` · Fone: ${cli.fone}` : ''}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className={vendastyles['divvendainputvalorbrl']}>
            <label className={`${ui.labdesktop}`}>Valor BRL</label>
            <div className={vendastyles['vendainputvalorbrl']}>
              <input className={`${ui.inpdesktop}`} type="text" placeholder="Valor BRL" {...register('valorBRL', { required: 'Valor BRL é obrigatório', pattern: { value: /^\d+(?:[\.,]\d{1,2})?$/, message: 'Use até 2 casas (ponto ou vírgula)' } })} />
              {errors.valorBRL && <span>{errors.valorBRL.message}</span>}
              <button
                type="button"
                onClick={() => abrirCalculadora('valorBRL')}
                className={`${ui.calcbtn} ${vendastyles['calc-inline']}`}
                aria-label="Abrir calculadora para Valor BRL"
              >
                <CgCalculator size={20} />
              </button>
            </div>
          </div>
        </div>
       

        <div className={vendastyles['venda-nomevalor']}>
          <div className={vendastyles['venda-autocomplete']}>
            <label className={`${ui.labdesktop}`}>Nome BOB</label>
            <input className={`${ui.inpdesktop}`} type="text" placeholder="Cliente BOB" {...register('nomeBOB')} />
          </div>
          <div className={vendastyles['divvendainputvalorbrl']}>
            <label className={`${ui.labdesktop}`}>Valor BOB</label>
            <div className={vendastyles['vendainputvalorbrl']}>
              <input className={`${ui.inpdesktop}`} type="text" placeholder="Valor BOB" {...register('valorBOB', { pattern: { value: /^\d+(?:[\.,]\d{1,2})?$/, message: 'Use até 2 casas (ponto ou vírgula)' } })} />
              <button
                type="button"
                onClick={() => abrirCalculadora('valorBOB')}
                className={`${ui.calcbtn} ${vendastyles['calc-inline']}`}
                aria-label="Abrir calculadora para Valor BOB"
              >
                <CgCalculator size={20} />
              </button>
              {errors.valorBOB && <span>{errors.valorBOB.message}</span>}
              </div>
          </div>
        </div>
      <div className={`${ui.divbutsalvar}`}>
        <button className={`${ui.butdesktop} ${ui.btnPrimary}`} type="submit">{isEditing ? 'Atualizar' : 'Salvar'}</button>
      </div>
      </form>

      {showCalculadora && (
        <div className={`${ui.divnegratelatotal}`} >
          <Calculadora onClose={(res) => aoFecharCalculadora(res)} />
        </div>
      )}
    </div>
  );
};

export default FormularioCompra;
// Helper período mês atual (YYYY-MM-DD)
const getMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const toISO = (d) => d.toISOString().slice(0, 10);
  return { start: toISO(start), end: toISO(end) };
};
